import { Box, Typography } from "@mui/material";
import WSButton from "../../Components/Button/WSButton";
import { WSIcons } from "../../commonFunctions/iIcons";

export const NotFound = ({ onRetry }: { onRetry?: () => void }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="70vh"
      textAlign="center"
    >
      <WSIcons.ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h5" fontWeight="bold" color="error">
        Bill Not Found!
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mt: 1, mb: 3 }}>
        We couldn’t find the bill you’re looking for. It may have been removed
        or doesn’t exist.
      </Typography>
      {onRetry && (
        <WSButton id="retry" variant="contained" color="primary" onClick={onRetry} label="Retry"/>
      )}
    </Box>
  );
};
